<template>
  <div class="userManagement-container">
    <vab-query-form>
      <el-form :inline="true" :model="queryForm" @submit.native.prevent>
        <el-form-item label="用户昵称">
          <el-input v-model.trim="queryForm.nickname" placeholder="请输入昵称" clearable @keyup.enter.native="queryData" />
        </el-form-item>
        <el-form-item label="用户编号">
          <el-input v-model.trim="queryForm.code" placeholder="请输入编号" clearable @keyup.enter.native="queryData" />
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input v-model.trim="queryForm.mobile" placeholder="请输入手机号" clearable @keyup.enter.native="queryData" />
        </el-form-item>
        <el-form-item label="用户邮箱">
          <el-input v-model.trim="queryForm.email" placeholder="请输入邮箱" clearable @keyup.enter.native="queryData" />
        </el-form-item>
        <el-form-item label="注册邀请码">
          <el-input v-model.trim="queryForm.invitation_code" placeholder="请输入注册邀请码" clearable
            @keyup.enter.native="queryData" />
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="queryData">
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </vab-query-form>

    <el-table ref="tableSort" v-loading="listLoading" :data="list" :height="height"
      :element-loading-text="elementLoadingText" border @selection-change="setSelectRows"
      @sort-change="tableSortChange">
      <!-- 用户id -->
      <el-table-column prop="id" label="序号" align="center" width="120" sortable></el-table-column>
      <!-- 用户头像 -->
      <el-table-column show-overflow-tooltip label="用户头像" align="center">
        <template #default="{ row }">
          <el-image v-if="imgShow" :preview-src-list="imageList" :src="row.pic"></el-image>
        </template>
      </el-table-column>
      <!-- 用户昵称 -->
      <el-table-column prop="nickname" label="用户昵称" align="center"></el-table-column>
      <!-- 用户手机号 -->
      <el-table-column prop="mobile" label="用户手机号" align="center"></el-table-column>
      <!-- 邮箱 -->
      <el-table-column prop="email" label="用户邮箱" align="center"></el-table-column>
      <!-- 用户ID -->
      <el-table-column prop="code" label="用户MGK编号" align="center"></el-table-column>
      <el-table-column prop="kor_code" label="用户ZDH编号" align="center"></el-table-column>
      <el-table-column prop="ydm_code" label="用户YDM编号" align="center"></el-table-column>
      <el-table-column prop="cm_code" label="用户CM编号" align="center"></el-table-column>
      <el-table-column prop="invitation_code" label="注册邀请码" align="center"></el-table-column>
      <el-table-column prop="points" label="用户积分" align="center"></el-table-column>
      <!-- 创建时间 -->
      <el-table-column show-overflow-tooltip prop="add_time" label="创建时间" align="center" sortable></el-table-column>
      <el-table-column show-overflow-tooltip label="操作面板" width="250" align="center">
        <template #default="{ row }">
          <!-- <el-button type="" size="mini"  @click="handledetail(row)">详情</el-button> -->
          <!-- 客服 -->
          <el-button type="warning" icon="el-icon-headset" size="mini" @click="toKF(row)"></el-button>
          <el-button type="text" size="mini" @click="handleEdit(row)">
            编辑
          </el-button>
          <el-button type="text" size="mini" style="color: red" @click="handleDelete(row)">
            删除
          </el-button>
          <el-button type="text" size="mini" @click="showPoint(row)">
            积分记录
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="isShowPage" background :current-page="queryForm.page" :page-sizes="[10, 30, 50]"
      :page-size="queryForm.limit" :layout="layout" :total="total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange"></el-pagination>
    <edit ref="edit" :user-list="userList" @fetch-data="fetchData"></edit>
    <includingPoints ref="Points"></includingPoints>
    <!-- <user-details ref="edit1" @fetch-data="fetchData"></user-details> -->
  </div>
</template>

<script>
import Edit from './components/UserManagementEdit'
import includingPoints from './components/including_points.vue'

import { memberList, memberDel, user_list, memberListAll } from '@/api/xgcApi'
export default {
  name: 'UserManagement',
  components: {
    Edit,
    includingPoints,
  },
  data() {
    return {
      height: '74vh',
      imageList: [],
      imgShow: true,
      userList: [],
      list: [],
      listLoading: false,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      elementLoadingText: '正在加载...',
      queryForm: {
        page: 1,
        limit: 10,
      },
      isShowPage: false,
    }
  },
  created() {
    this.fetchData()
    this.userLists()
  },
  methods: {
    // 跳转客服链接
    toKF(row) {
      let uid = row.uid
      window.open(
        `https://call.youdaexpress.com/service?uid=${uid}&u_name=${row.user_name}`,
        '_blank', // 目标窗口：_blank(新标签)/_self(当前)/自定义名称
      );
    },
    showPoint(row) {
      console.log(row)
      this.$refs.Points.showEdit(row)
    },
    remoteMethod(e) {
      this.page = 1
      this.limit = 20
      var data = {
        nickname: e,
        page: 1,
        limit: 100,
      }
      memberListAll(data).then(({ data }) => {
        this.options = data
      })
    },
    userLists() {
      user_list(this.queryForm).then((res) => {
        this.userList = res.data.list
      })
    },
    tableSortChange() {
      const imageList = []
      this.$refs.tableSort.tableData.forEach((item, index) => {
        imageList.push(item.img)
      })
      this.imageList = imageList
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    // 编辑用户列表
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    // 用户信息详情
    // handledetail(row) {
    //    this.$refs['edit1'].getHdzDetail(row)
    //   // this.$router.push({ path: './user', query: { id: row.id } })
    // },
    // 删除用户列表
    handleDelete(row) {
      this.$baseConfirm('你确定要删除当前项吗', null, async () => {
        const { msg } = await memberDel(row.id)
        this.$baseMessage(msg, 'success')
        this.fetchData()
      })
    },
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    // 查询
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    // 请求列表数据
    async fetchData() {
      this.listLoading = true
      const { data } = await memberList(this.queryForm)
      this.list = data.list
      const imageList = []
      data.list.forEach((item, index) => {
        imageList.push(item.pic)
      })
      this.imageList = imageList
      if (this.list.length > 0) {
        this.isShowPage = true
      } else {
        this.isShowPage = false
      }
      this.total = data.count
      setTimeout(() => {
        this.listLoading = false
      }, 500)
    },
  },
}
</script>
